import{Defer}from"@olmokit/utils/Defer";import{Emitter}from"@olmokit/utils/Emitter";import{getUrlQueryParams}from"@olmokit/utils/getUrlQueryParams";import{isFunction}from"@olmokit/utils/isFunction";import{isString}from"@olmokit/utils/isString";import{$}from"@olmokit/dom/$";import{addClass}from"@olmokit/dom/addClass";import{listen}from"@olmokit/dom/listen";import{off}from"@olmokit/dom/off";import{on}from"@olmokit/dom/on";import{removeClass}from"@olmokit/dom/removeClass";import{setVendorCSS}from"@olmokit/dom/setVendorCSS";import{navigateToMergedParams}from"@olmokit/browser/navigateToMergedParams";import{navigateWithoutUrlParam}from"@olmokit/browser/navigateWithoutUrlParam";import scrollLock,{fillGapsOf}from"../scroll/lock";import{DIALOG_ATTR_CLOSE}from"./helpers";import"./index.scss";/**
 * Dialog instances in memory
 *
 * @internal
 */let instances={};/**
 * Dialog, a simple, reusable and extendable dialog function. It only manages
 * standard dialog beahaviour and accesibility.
 *
 * for inspiration @see https://github.com/ghosh/Micromodal
 * TODO: trap focus perhaps with @see https://www.npmjs.com/package/tabbable
 *
 * @param rooter The DOM selector to run the dialog upon, defaults to `".dialog"`
 */export function Dialog(rooter,options={},hooks={}){let lastActiveElement,$root,$wrap,$content,$backdrop,$cage;let{id}=options;if(id&&instances[id])return instances[id];let CLASS_LOADING="is-loading",{tpl,rootClass,transition=300,gaps}=options,{mounted,rendered,opening,opened,closing,closed}=hooks,{emit,on:onEvent}=Emitter("dialog"),willOpen=Defer();if(isFunction(rooter)){let skeleton=rooter();$root=skeleton.$root,$backdrop=skeleton.$backdrop,$cage=skeleton.$cage,$wrap=skeleton.$wrap,$content=skeleton.$content}else{if(!($root=isString(rooter)?$(rooter):rooter))return;$backdrop=$(".dialogBackdrop",$root),$cage=$(".dialogCage",$root),$wrap=$(".dialogWrap",$root),$content=$(".dialogContent",$root)}let instance={id,$root,$cage,$wrap,$content,willOpen,opened:!1,render,open:/**
   * Open
   *
   * @public
   */function(customData){return lastActiveElement=document.activeElement,$root.style.display="block",setTimeout(()=>{addClass($root,"is-in")},3),opening&&opening(instance,customData),emit("opening",customData),udpdateDeeplink(instance.id,!0),gaps&&fillGapsOf(gaps),scrollLock.disable($cage),setTimeout(()=>{opened&&opened(instance,customData),instance.opened=!0,emit("opened",customData),willOpen.resolve()},transition+3),instance},close,destroy,load:// /**
//  * Event emitter function
//  *
//  * @param {string} name
//  * @param {any} [data]
//  */
// function emit(name, data) {
//   emitEvent(`${EVENT_NAMESPACE}${name}`, {
//     instance,
//     data,
//   });
// }
/**
   * Start loading async content
   *
   * @public
   */function(){addClass($root,CLASS_LOADING)},loaded:/**
   * End loading async content
   *
   * @public
   */function(){removeClass($root,CLASS_LOADING)},on:onEvent};/**
   * Populate dialog content with HTML, it calls the `rendered` hook
   *
   * @param silent Useful when emptying the dialog content and don't want the `rendered` callback to be called
   */function render(content,silent){$content.innerHTML=content,rendered&&!silent&&rendered(instance)}/**
   * Handle click
   *
   * @private
   */function handleClick(event){let el=event.target;el.hasAttribute(`data-${DIALOG_ATTR_CLOSE}`)&&(close(event),event.preventDefault())}/**
   * Handle keydown
   *
   * @private
   */function handleKeydown(event){27===event.keyCode&&close(event);// if (event.keyCode === 9) maintainFocus(event)
}/**
   * Destroy
   *
   * @public
   */function destroy(){off($root,"touchstart",handleClick),off($root,"click",handleClick),off(document,"keydown",handleKeydown),$root.parentNode?.removeChild($root)}/**
   * Close
   *
   * @public
   */function close(_event,customData){return closing&&closing(instance,customData),emit("closing",customData),udpdateDeeplink(instance.id,!1),lastActiveElement&&// @ts-expect-error FIXME: core types dialog
lastActiveElement?.focus(),removeClass($root,"is-in"),instance.opened=!1,setTimeout(()=>{$root.style.display="none",willOpen=Defer(),instance.willOpen=willOpen,id&&!instances[id]&&destroy(),scrollLock.enable($cage),closed&&closed(instance,customData),emit("closed",customData)},transition),instance}return tpl&&render(tpl),rootClass&&($root.className+=" "+rootClass),on($root,"touchstart",handleClick),on($root,"click",handleClick),on(document,"keydown",handleKeydown),setVendorCSS($backdrop,"transitionDuration",`${transition}ms`),setVendorCSS($wrap,"transitionDuration",`${transition}ms`),addClass($root,"has-init"),mounted&&mounted(instance),id&&(instances[id]=instance),instance}/**
 * Update url parameter for deeplinking
 */export function udpdateDeeplink(queryParam,opened){queryParam&&(opened?navigateToMergedParams({[queryParam]:!0},!0):navigateWithoutUrlParam(queryParam,!0))}/**
 * Basic auto intialisation of dialogs, it cactch links with the right data
 * attribute and prompt the dialog, same on load based on current query params
 *
 * @param method The instance method name to use to open the the dialog, this allows implementers to easily override the open behaviour
 */export function dialogInit(instance,method){method=method||"open";let queryParams=getUrlQueryParams();instance.id&&(listen("click",`[data-${instance.id}]`,/**
   * Handle click, hijack auth links to auth dialog
   */function(event){event.preventDefault(),// @ts-expect-error FIXME: dialog types
instance[method](event.target)}),queryParams[instance.id]&&// @ts-expect-error FIXME: dialog types
instance[method]())}export default Dialog;